module.exports = __webpack_public_path__ + "static/media/08.4a63f498.png";